import {
  mixinDialogMutations,
  mixinDialogActions,
  mixinDialogGetters
} from '@/mixins/vuexDialogs'
import moment from "moment";

import { getField, updateField } from 'vuex-map-fields'
import Cookies from 'js-cookie'
import router from '@/router'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    profile: {},
    profileAuthorized: false,
    token: '',
    alert: {
      color: '',
      message: ''
    },
    dialogs: {
      alert: false,
      unsubscribe: false,
      unsubscribePlan: false,
      capitalistDialog: false,
      cryptadiumDialog: false,
      cryptadiumUSDTDialog: false,
      enableTwoFactorAuthDialog: false,
      twoFactorAuthBackupCodesDialog: false,
      manageTwoFactorAuthDialog: false,
      confirmTwoFactorAuthDialog: false,
      turnOffTwoFactorAuthDialog: false,
      npsQuiz: false,
      popTwoFactor: false,
      showQuizBlock: false,
      affiliateDialogDeleteLinks: false,
      customPlanMoreProfiles: false,
      quizLeavePrompt: false
    },
    banners: {
      secondMonthPayment: false,
      backToSchool: false,
      blackFriday: false
    },
    usdRates: {
      RUB: 74
    },
    subscription: {
      daysCount: 0
    },
    successfulPaymentAlert: false,
    paymentDeclineAlert: false,
    paymentCancelAlert: false,
    successfulUpgradeAlert: false,
    queryParamPromo: '',
    showBannerSecondMonthOfferUntil: '',
    renewSecondMonthWithDiscount: false,
    twoFactorBackupCodes: [],
    twoFactorChangeDevice: false,
    twoFactorQrCode: '',
    twoFactorSecretKey: '',
    selectedMessenger: '',
    selectedMessengerValue: '',
    userChangedContactThisMonth: false,
    showAccountPanel: true,
    loading: {
      profile: false
    }
  },

  getters: {
    ...mixinDialogGetters,
    getField,

    profile: state => state.profile,
    alert: state => state.alert,
    usdRates: state => state.usdRates,
    successfulPaymentAlert: state => state.successfulPaymentAlert,
    successfulUpgradeAlert: state => state.successfulUpgradeAlert,
    queryParamPromo: state => state.queryParamPromo,
    paymentCancelAlert: state => state.paymentCancelAlert,
    paymentDeclineAlert: state => state.paymentDeclineAlert,
    banners: state => state.banners,
    showBannerSecondMonthOfferUntil: state => state.showBannerSecondMonthOfferUntil,
    renewSecondMonthWithDiscount: state => state.renewSecondMonthWithDiscount,
    twoFactorBackupCodes: state => state.twoFactorBackupCodes,
    twoFactorChangeDevice: state => state.twoFactorChangeDevice,
    userChangedContactThisMonth: state => state.userChangedContactThisMonth,
    showAccountPanel: state => state.showAccountPanel,
    twoFactorQrCode: state => state.twoFactorQrCode,
    twoFactorSecretKey: state => state.twoFactorSecretKey,
    selectedMessenger: state => state.selectedMessenger,
    selectedMessengerValue: state => state.selectedMessengerValue,
    loading: state => state.loading,
    showQuizBlock: state => state.dialogs.showQuizBlock,
  },

  mutations: {
    ...mixinDialogMutations,
    updateField,

    SET_ALERT: (state, alert) => {
      state.alert = alert
    },

    OPEN_ALERT: (state) => {
      state.dialogs.alert = true
    },

    SHOW_BANNER: (state, key) => {
      state.banners[key] = true
    },

    HIDE_BANNER: (state, key) => {
      state.banners[key] = false
    },

    CLOSE_ALERT: (state) => {
      state.dialogs.alert = false
    },

    SET_PROFILE: (state, payload) => {
      state.profile = payload
      state.profile.balance = payload.balance || 0
    },

    UPDATE_PROFILE_LOCALLY: (state, payload) => {
      state.profile = Object.assign(state.profile, payload)
    },

    SET_USD_RATES: (state, payload) => {
      state.usdRates = payload
    },
    SET_TOKEN: (state, token) => {
      state.token = token
      if (token)
        state.profileAuthorized = true
    },

    SET_QUERY_PARAM_PROMO: (state, promo) => {
      state.queryParamPromo = promo
    },

    SET_DOWNLOAD_MENU_GROUP: (state, payload) => {
      state.downLoadMenuGroup = payload;
    },

    SET_SHOW_BANNER_SECOND_MONTH_OFFER_UNTIL: (state, payload) => {
      state.showBannerSecondMonthOfferUntil = payload;
    },

    SET_RENEW_SECOND_MONTH_WITH_DISCOUNT: (state, payload) => {
      state.renewSecondMonthWithDiscount = payload
    },

    SET_TWO_FACTOR_BACKUP_CODES: (state, codes) => {
      state.twoFactorBackupCodes = codes
    },

    SET_TWO_FACTOR_CHANGE_DEVICE: (state, payload) => {
      state.twoFactorChangeDevice = payload
    },

    SET_USER_CHANGED_CONTACT_THIS_MONTH: (state, payload) => {
      state.userChangedContactThisMonth = payload
    },

    SET_SHOW_ACCOUNT_PANEL: (state, payload) => {
      state.showAccountPanel = payload
    },

    SET_TWO_FACTOR_QR_CODE: (state, payload) => {
      state.twoFactorQrCode = payload
    },

    SET_TWO_FACTOR_SECRET_KEY: (state, payload) => {
      state.twoFactorSecretKey = payload
    },

    SET_SELECTED_MESSENGER: (state, payload) => {
      state.selectedMessenger = payload
    },

    SET_SELECTED_MESSENGER_VALUE: (state, payload) => {
      state.selectedMessengerValue = payload
    },

    SET_LOADING: (state, { key, value }) => {
      state.loading[key] = value
    },

    SET_SHOW_QUIZ_BLOCK: (state, value) => {
      state.dialogs.showQuizBlock = value
    },
  },

  actions: {
    ...mixinDialogActions,

    setQuizBlock({commit}, value) {
      commit('SET_SHOW_QUIZ_BLOCK', value)
    },

    async alert (context, alert) {
      context.commit('CLOSE_ALERT')
      context.commit('SET_ALERT', alert)
      context.commit('OPEN_ALERT')
      setTimeout(() => {
        context.commit('CLOSE_ALERT')
      }, 5000)
    },
    async setToken ({commit}, token) {
      commit("SET_TOKEN", token)
    },

    async closeAlert (context) {
      context.commit('CLOSE_ALERT')
    },

    async loadProfileForVerification(context, { accessToken, refreshToken }) {
      try {
        const response = await this._vm.api.get('/profile/?with_ref_stat=1',
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          })

        const { status, data } = response
        if (status === 200) {
          if (data && data.data && data.data.shouldVerifyEmail && !data.data.email_verified_at) {
            localStorage.setItem('isEmailConfirmed', 'false')

            await context.dispatch('auth/setIsEmailConfirmed', false, { root: true })
          } else if (accessToken) {
            // Email is confirmed
            localStorage.setItem('isEmailConfirmed', 'true')

            Cookies.set('dolphinAntyAccessToken', window.decodeURIComponent(window.btoa(accessToken)));
            Cookies.set('dolphinAntyRefreshToken', window.decodeURIComponent(window.btoa(refreshToken)));

            this._vm.api.defaults.headers.Authorization = `Bearer ${accessToken}`
            this._vm.apiV2.defaults.headers.Authorization = `Bearer ${accessToken}`

            await context.dispatch('auth/setIsAuthenticated', accessToken, { root: true })

            if (!window.location.href.includes('verified=1')) {
              localStorage.setItem('quizRequired', '0')
            }

            await router.push({ name: 'Overview' });
          }
        }
      } catch (err) {
        console.log(err)
      }
    },

    async loadProfile (context) {
      context.commit('SET_LOADING', { key: 'profile', value: true })

      try {
        const response = await this._vm.api.get('/profile/?with_ref_stat=1')

        const { status, data } = response

        if (status === 200) {
          const subscription = await this._vm.api.get('/subscription')

          if (subscription.status === 200 && subscription.data && subscription.data.data) {
            await context.commit('SET_PROFILE', Object.assign({}, data.data,  { subscription: subscription.data.data }))

            await context.dispatch('experiments/setExperiments', data.data.experiments, { root: true })
          }

          if (data && data.data && data.data.username) {
            // Second month payment offer experiment
            if (data.data.showBannerSplitTestC2OfferUntil) {
              const duration = moment(data.data.showBannerSplitTestC2OfferUntil).diff(new Date().toISOString(), 'seconds', false)

              if (duration > 0) {
                await context.commit('SET_SHOW_BANNER_SECOND_MONTH_OFFER_UNTIL', data.data.showBannerSplitTestC2OfferUntil)

                await context.commit('SHOW_BANNER', 'secondMonthPayment')
              }
            }

            this._vm.$amplitude.getInstance().setUserId(data.data.username)
          }
        }
      } catch (_) {
        //
      } finally {
        context.commit('SET_LOADING', { key: 'profile', value: false })
      }
    },

    async updateProfileLocally (context, payload) {
      context.commit('UPDATE_PROFILE_LOCALLY', payload)
    },

    async showBanner (context, key) {
      context.commit('SHOW_BANNER', key)
    },

    async hideBanner (context, key) {
      context.commit('HIDE_BANNER', key)
    },

    async loadUsdRates (context) {
      const response = await this._vm.api.get('/subscription/currency-rates')

      if (response.status === 200 && response.data) {
        context.commit('SET_USD_RATES', response.data)
      }
    },

    setPromoFromQueryParam (context, promo) {
      context.commit('SET_QUERY_PARAM_PROMO', promo)
    },

    setDownloadMenuGroup (context, group) {
      context.commit('SET_DOWNLOAD_MENU_GROUP', group)
    },

    setRenewSecondMonthWithDiscount ({ commit }, payload) {
      commit('SET_RENEW_SECOND_MONTH_WITH_DISCOUNT', payload)
    },

    setShowBannerSecondMonthUntil ({ commit }, payload) {
      commit('SET_SHOW_BANNER_SECOND_MONTH_OFFER_UNTIL', payload)
    },

    async setTwoFactorBackupCodes (context, codes) {
      context.commit('SET_TWO_FACTOR_BACKUP_CODES', codes)
    },

    async setTwoFactorChangeDevice (context, payload) {
      context.commit('SET_TWO_FACTOR_CHANGE_DEVICE', payload)
    },

    async setUserChangedContactThisMonth (context, payload) {
      context.commit('SET_USER_CHANGED_CONTACT_THIS_MONTH', payload)
    },

    async setUserShowAccountPanel (context, payload) {
      context.commit('SET_SHOW_ACCOUNT_PANEL', payload)
    },

    async setTwoFactorQrCode (context, payload) {
      context.commit('SET_TWO_FACTOR_QR_CODE', payload)
    },

    async setTwoFactorSecretKey (context, payload) {
      context.commit('SET_TWO_FACTOR_SECRET_KEY', payload)
    },

    async setSelectedMessenger (context, payload) {
      context.commit('SET_SELECTED_MESSENGER', payload)
    },

    async setSelectedMessengerValue (context, payload) {
      context.commit('SET_SELECTED_MESSENGER_VALUE', payload)
    },

    async setProfile (context, payload) {
      context.commit('SET_PROFILE', payload)
    },

    async getUserGeolocation ({ dispatch }) {
      try {
        const { status, data = {} } = await axios.get(process.env.VUE_APP_GEOIP_API)

        if (status === 200 && data?.country_code) {
          dispatch('plans/setCountryCode', data.country_code, { root: true })

          return data
        }

        console.warn('getUserGeolocation: no country_code in response', { status, data })
      } catch (err) {
        console.error('getUserGeolocation failed:', err)
      }
    }
  }
}
